import ReactForm from './ReactForm.vue'

export default ReactForm
